import { render, staticRenderFns } from "./wxOpenAppLayout.vue?vue&type=template&id=5faea999"
import script from "./wxOpenAppLayout.vue?vue&type=script&lang=js"
export * from "./wxOpenAppLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports